/**
 * @generated SignedSource<<eb80d9447dbba609d736aeb4e3a41060>>
 * @relayHash d165b7da9e98184c4bd88b7612dcbb7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d4c22a4c8f3ad6550b9a32a1b0fb40f9a30a5742ffe72062e0e7b0711c793fc4

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceTrackType = "BRIEFING" | "NARRATION" | "%future added value";
export type PlaylistQuery$variables = {
  cloudId: string;
};
export type PlaylistQuery$data = {
  readonly confluence_getPlaylist: {
    readonly tracks: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly mainContent: {
          readonly history: {
            readonly createdBy: {
              readonly displayName: string | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly id: string | null | undefined;
          readonly properties: {
            readonly nodes: ReadonlyArray<{
              readonly value: string | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly space: {
            readonly key: string | null | undefined;
          } | null | undefined;
          readonly subType: string | null | undefined;
          readonly title: string | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
        readonly type: ConfluenceTrackType;
      }>;
    };
  } | null | undefined;
};
export type PlaylistQuery = {
  response: PlaylistQuery$data;
  variables: PlaylistQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "type"
},
v4 = {
  "kind": "ScalarField",
  "name": "title"
},
v5 = {
  "kind": "ScalarField",
  "name": "subType"
},
v6 = {
  "kind": "ScalarField",
  "name": "key"
},
v7 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v8 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\"])"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PlaylistQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluencePlaylist",
        "kind": "LinkedField",
        "name": "confluence_getPlaylist",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluencePaginatedTracks",
            "kind": "LinkedField",
            "name": "tracks",
            "plural": false,
            "selections": [
              {
                "concreteType": "ConfluenceTrack",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "mainContent",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v3/*: any*/),
                      (v5/*: any*/),
                      {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "History",
                        "kind": "LinkedField",
                        "name": "history",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v8/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PlaylistQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluencePlaylist",
        "kind": "LinkedField",
        "name": "confluence_getPlaylist",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluencePaginatedTracks",
            "kind": "LinkedField",
            "name": "tracks",
            "plural": false,
            "selections": [
              {
                "concreteType": "ConfluenceTrack",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "mainContent",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v3/*: any*/),
                      (v5/*: any*/),
                      {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v2/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "History",
                        "kind": "LinkedField",
                        "name": "history",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__typename"
                              },
                              (v7/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v8/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d4c22a4c8f3ad6550b9a32a1b0fb40f9a30a5742ffe72062e0e7b0711c793fc4",
    "metadata": {},
    "name": "PlaylistQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1be20bb5ef9aa0dbdd2231ac10bf984f";

export default node;
